import { IForm } from 'core-components/classes/models/IForm'

export const mapRequestProcessesProgressFromCrud = (data: IForm[]): IObjectAny[] =>
  data.map((source: IForm) => ({
    RequestId: source.RequestId || 0,
    Process: source.Process || '',
    Proportion: source.Proportion || 0,
  }))
